import { useMemo } from 'react';
import { QuestionOption, AnswersOptions } from '@/types/api';
import TrendDistributionComponent from './TrendDistribution.component';

type TrendDistributionContainerProps = {
  title: string;
  height?: string;
  options: QuestionOption[];
  answers: AnswersOptions[];
  children?: React.ReactNode;
};

const TrendDistributionContainer = function ({
  title,
  options,
  answers,
  height,
  children,
}: TrendDistributionContainerProps): JSX.Element {
  const labels = useMemo(
    () =>
      options.map((option) => option.label).sort((a, b) => parseInt(a, 10) - parseInt(b, 10)) || [],
    [options]
  );

  const answersAmount = useMemo(
    () =>
      labels.map((label) => {
        const foundData = answers.find((answer) => answer.label === parseInt(label, 10));
        return foundData?.count || 0;
      }) || [],
    [labels, answers]
  );

  return (
    <TrendDistributionComponent
      labels={labels}
      answersAmount={answersAmount}
      title={title}
      height={height}
    >
      {children}
    </TrendDistributionComponent>
  );
};

export default TrendDistributionContainer;
